module.exports = __webpack_public_path__ + "static/media/12.dbff2f68.jpeg";